<div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<ng-container>
    <app-dynamic-grid [config]="gridConfig" [clauses]="gridClause" [trail]="gridTrail" [report]="gridReport"
        [settings]="gridSettings" (add)="onAddEmit()" (edit)="onEditEmit($event)"
        (delete)="onDeleteEmit($event)"></app-dynamic-grid>
</ng-container>

<ng-template #addAndEditPopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditPopup()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupTitle }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <div>
            <div class="row">
                <div class="col-md-6">
                    <div>
                        <label id="finding" for="email">
                            {{dynamicLabel['FINDING_SHORT_DESCRIPTION']}}
                        </label> <span class="mandatory-symbol">*</span>
                    </div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="ecFinding.findingId"
                        (closed)="findingSearchText=''" (click)="focusSearch('focus-finding')"
                        (keydown.enter)="focusSearch('focus-finding')" [disabled]="isFrozen">
                        <input type="search" id="focus-finding" class="dropdownsearchstyle"
                            [(ngModel)]="findingSearchText" matInput placeholder="search">
                        <mat-option [value]="null" class="unselectStyle"
                            (onSelectionChange)="onFindingSelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of findingsDropdown | assessmentSearch : findingSearchText"
                            (onSelectionChange)="onFindingSelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>

                <div class="col-md-6">
                    <div>
                        <label id="methodology-validation" for="email">
                            {{dynamicLabel['METHODOLOGY']}}
                        </label> <span class="mandatory-symbol">*</span>
                    </div>
                    <mat-select matInput placeholder="Select" [(ngModel)]="ecFinding.methodology"
                        (closed)="methodologySearchText=''" (click)="focusSearch('focus-methodology')"
                        (keydown.enter)="focusSearch('focus-methodology')" [disabled]="isFrozen">
                        <input type="search" id="focus-methodology" class="dropdownsearchstyle"
                            [(ngModel)]="methodologySearchText" matInput placeholder="search">
                        <mat-option [value]="null" class="unselectStyle"
                            (onSelectionChange)="onMethodologySelect($event,null);">Un-select</mat-option>
                        <mat-option *ngFor="let item of methodologyDropdown | assessmentSearch : methodologySearchText"
                            (onSelectionChange)="onMethodologySelect($event,item)" [value]="item.valueExp">
                            {{ item.displayExp }}
                        </mat-option>
                    </mat-select>
                </div>

                <div class="col-md-6">
                    <div>
                        <label id="criteria" for="email">
                            {{dynamicLabel['CRITERIA']}}
                        </label> <span class="mandatory-symbol">*</span>
                    </div>
                    <div class="row">
                        <div class="row d-flex align-items-center">
                            <div class="hideToolbar col-sm-11">
                                <st-editor [(ngModel)]="ecFinding.criteria" [config]="excludeButtons"
                                    style="min-height: 100px !important;" [spellcheck]="true" [disabled]="isFrozen"
                                    (paste)="onPaste($event)">
                                </st-editor>
                            </div>
                            <div class="col-sm-1 angular-editor-edit"
                                (click)="isFrozen ? openEditor('Criteria', 'eye') : openEditor('Criteria', 'edit')"
                                (keydown.enter)="isFrozen ? openEditor('Criteria', 'eye') : openEditor('Criteria', 'edit')">
                                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-md-6" *ngIf="showConclusion || ecFinding.conclusion">
                    <div>
                        <label for="email">
                            {{dynamicLabel['CONCLUSION']}}
                        </label> <span class="mandatory-symbol">*</span>
                    </div>
                    <div class="row">
                        <div class="row d-flex align-items-center">
                            <div class="hideToolbar col-sm-11">
                                <st-editor [(ngModel)]="ecFinding.conclusion" [config]="excludeButtons"
                                    style="min-height: 100px !important;" [spellcheck]="true" [disabled]="isFrozen"
                                    (paste)="onPaste($event)">
                                </st-editor>
                            </div>
                            <div class="col-sm-1 angular-editor-edit"
                                (click)="isFrozen ? openEditor('Conclusion', 'eye') : openEditor('Conclusion', 'edit')"
                                (keydown.enter)="isFrozen ? openEditor('Conclusion', 'eye') : openEditor('Conclusion', 'edit')">
                                <i *ngIf="!isFrozen" class="far fa-edit"></i>
                                <i *ngIf="isFrozen" class="fa fa-eye eye"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="addButton" (click)="addAndEditFunction(ecFinding)" *ngIf="!isFrozen">
                <ng-container *ngIf="operationFlag == 'ADD'"><i class="fas fa-plus"></i> Add</ng-container>
                <ng-container *ngIf="operationFlag == 'EDIT'"><i class=" fas fa-user-edit"></i> Update</ng-container>
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditPopup()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>

<ng-template #editor>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelEditor()" mat-button>
        <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ editorTitle }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div><br>
    <div class="row">
        <div class="col-md-12 st-editor">
            <st-editor [(ngModel)]="editorValue" [config]=" allowEditing ? includeButtons : excludeButtons"
                [spellcheck]="true" (paste)="onPaste($event)"></st-editor>
        </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" *ngIf="allowEditing" (click)="saveEditor(editorValue)">
            <i class="fas fa-check"></i> Save
        </button>
        <button mat-stroked-button class="cancelButton" (click)="cancelEditor()">
            <i class="fa fa-close"></i> Cancel
        </button>
    </div>
</ng-template>

<ng-template #deletePopup>
    <div class="page-loading-shade" *ngIf="isProcessing">
        <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
            class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
        <label for="title" class="popupTitle"> {{ popupTitle }}</label>
        <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div style="margin: 15px 15px;">
        <div>
            <div class="row">
                <div class="col-md-12">
                    <div>
                        <label id="delete-reason" for="email">Reason for Delete</label>
                        <span class="mandatory-symbol">*</span>
                    </div>
                    <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4" cols="50"
                        [(ngModel)]="ecFinding.deleteReason"
                        (ngModelChange)="onNgModelChange($event,'delete-reason')"></textarea>
                </div>
            </div>
        </div>
        <div class="button-continer btn-align" mat-dialog-actions>
            <button mat-stroked-button class="deleteButton" (click)="deleteFunction(ecFinding)">
                <i class="fa fa-trash"></i> Delete
            </button>
            <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
                <i class="fa fa-close"></i> Cancel
            </button>
        </div>
    </div>
</ng-template>